// extracted by mini-css-extract-plugin
module.exports = {"orderToggle":"BaseOrderListOrderToggle_orderToggle_3z51K","orderToggleList":"BaseOrderListOrderToggle_orderToggleList_20Gty","footList":"BaseOrderListOrderToggle_footList_1V_qF"};